import { AppDispatch } from 'redux/store';
import { refreshAccount } from 'redux/actions/account';
import { actions as activeAccountActions } from 'redux/slices/account';
import { fungibleTokensService } from 'services/fungible-tokens';
import { BALANCES_PAGE } from 'site-settings/site-navigation';
import { wallet } from 'utils/wallet';

import config from 'config';
const { OPN_CONTRACT, OCC_CONTRACT, USDC_CONTRACT } = config;

const { actionAccountCheckBalance, actionAccountLoading, clearAccount } =
  activeAccountActions;

export const REGISTER_CONTRACTS = [
  OPN_CONTRACT,
  OCC_CONTRACT,
  USDC_CONTRACT
].filter(Boolean);

type ConnectOptions = {
  dispatch: AppDispatch;
  openModal: (view: any) => void;
  closeModal: () => void;
  navigate: (path: string) => void;
  forceConnect?: boolean;
};

/**
 * Always starts a fresh Meteor session: clears local keys, asks for new ones,
 * then opens Register if storage registration is still needed.
 */
export const connectWalletAndResolveAccess = async ({
  dispatch,
  openModal,
  closeModal,
  navigate
}: ConnectOptions) => {
  // Drop current app/wallet session before asking for a new account.
  dispatch(clearAccount());

  const connected = await wallet.requestSignIn({ forceConnect: true });
  if (!connected) {
    return { connected: false, needsRegistration: false };
  }

  await dispatch(refreshAccount());
  const accountId = wallet.accountId;
  if (!accountId) {
    return { connected: false, needsRegistration: false };
  }

  await Promise.all(
    REGISTER_CONTRACTS.map((contractName) =>
      dispatch(actionAccountCheckBalance({ contractName, accountId }))
    )
  );
  dispatch(actionAccountLoading());

  const needsRegistration = (
    await Promise.all(
      REGISTER_CONTRACTS.map((contractName) =>
        fungibleTokensService.isStorageBalanceAvailable({
          contractName,
          accountId
        })
      )
    )
  ).some((isRegistered) => !isRegistered);

  if (needsRegistration) {
    openModal('REGISTER_VIEW');
    return { connected: true, needsRegistration: true };
  }

  closeModal();
  navigate(BALANCES_PAGE);
  return { connected: true, needsRegistration: false };
};
